import { render, staticRenderFns } from "./projectSearchComponent.vue?vue&type=template&id=75353886&scoped=true&"
import script from "./projectSearchComponent.vue?vue&type=script&lang=js&"
export * from "./projectSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./projectSearchComponent.vue?vue&type=style&index=0&id=75353886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75353886",
  null
  
)

export default component.exports